import React from "react";

const MaterialIcon = (props) => {
    return <span className={`material-icons ${props.className}`}>{props.icon}</span>;
};

export default MaterialIcon;
